import React from 'react';

function ItemList({ items, removeItem }) {
  return (
    <ul className="list-group mb-4">
        {items.map((item, index) => (
        <li key={index} className="list-group-item">
            {item} <button onClick={() => removeItem(item)} className="btn btn-danger btn-sm">Delete</button>
        </li>
        ))}
    </ul>
  );
}

export default ItemList;